import Head from "next/head";
import Link from "next/link";
import React from "react";
import { NextPage } from "next";

import { IPageProps } from "../_app";
import CloudLogo from "src/components/logos/CloudLogo";
import SignupCallout from "src/components/sales/SignupCallout";
import PlatformExploreBanner from "src/components/sales/PlaformExploreBanner";
import { socialMetadata } from "src/components/layout/Head";

const Cloud: NextPage<IPageProps> = ({ signup }) => (
  <>
    <Head>
        {socialMetadata({
          title: "HASH Cloud",
          description: "One-click supercomputing for everyday decision-making",
        })}
    </Head>
    <div className="platform-page cloud">
      <div className="mainsite-header with-breadcrumb with-image">
        <div className="container">
          <div className="header-image">
            <CloudLogo />
          </div>
          <div className="header-text">
            <div className="mainsite-breadcrumb">
              <Link href="/platform">
                <a>
                  Platform <span>{">"}</span>
                </a>
              </Link>
            </div>
            <div className="mainsite-title">
              <h1 className="heading-1">
                <span className="bright-blue">h</span>Cloud
              </h1>
              <p className="large-text">
                One-click supercomputing for everyday decision-making
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="platform-content">
        <div className="container">
          <h3 className="heading-4">HOW IT WORKS</h3>

          <div className="paras">
            <div className="para">
              <h2 className="para-title">Fastest speed, lowest cost</h2>
              <p>
                <strong>hCloud</strong> lets you specify time-to-answer and
                cost-of-compute constraints, so you can ensure that answers
                arrive in time, and in budget. You can even scale resources up
                or down during an experiment run as more becomes known, and
                circumstances on the ground change.
              </p>
            </div>

            <div className="para">
              <h2 className="para-title">Automatic runtime optimization</h2>
              <p>
                <strong>hCloud</strong> can optionally apply dozens of unique
                optimizations to your simulation, lowering your cost of compute,
                and enabling simulations to be run both faster and cheaper than
                otherwise achievable.
              </p>
            </div>

            <div className="para">
              <h2 className="para-title">Economies of scale</h2>
              <p>
                We buy compute in bulk in order to lower the cost of processing
                computationally complex and large-scale simulations.
              </p>
              <p>
                As our community grows, so do our economies of scale, and you
                should expect your costs to decrease over time.
              </p>
            </div>
          </div>
        </div>

        <div className="form-wrapper">
          <SignupCallout
            Icon={<CloudLogo />}
            interest="CLOUD"
            purple
            signup={signup}
            subtitle="Get 600 minutes free compute each and every month"
            title="Simulate in the cloud for free"
          />
        </div>

        <PlatformExploreBanner exclude="Cloud" />
      </div>
    </div>
  </>
);

export default Cloud;
